module.exports = __webpack_public_path__ + "static/media/mf.d7647f6c.svg";